// Initial state for PostJob component
const postJobInitialState = {
  jobTitle: "",
  location: "",
  company: "",
  group: "",
  industry: "",
  joblength: "",
  travelRequired: "",
  salary: "",
  description: "",
  jobStartDate: "",
  jobEndDate: "",
  country: "",
  countryState: "",
  countryList: [],
  countryStateList: [],
  industryList: [],
  groupList: [],
  city: "",
  state: "",
  address1: "",
  address2: "",
  zip: "",
  contactName: "",
  contactEmail: "",
  telephone: "",
  position: "",
  category: "",
  jobength: "",
  jobLength: "",
  responsibilities: "",
  companyError: false,
  groupError: false,
  cityError: false,
  stateError: false,
  contactNameError: false,
  emailError: false,
  industryError: false,
  positionError: false,
  joblengthError: false,
  travelError: false,
  descriptionError: false,
  jobTypeId: null,
  postLink: "",
  telecommute: "",
  jobType: "",
  showStateTextBox: false,
  stateName: "",
  jobTypeIdError: false,
  startDateError: false,
  endDateError: false,
  addressError: false,
  countryStateError: false,
  postType: "",
  phoneValidError: false,
  companyNameValidError: false,
  stateValidError: false,
  cityValidError: false,
  zipValidError: false,
  nameValidError: false,
  emailValidError: false,
  positionValidError: false,
  resultState: false,
  linkError: false,
  linkValidError: false,
  disablePost: false,
  disableDraft: false,
  draftsCount: "",
  industryNameForActivity: "",
  ProfanitiesWords: null,
  validCompanyContentError: false,
  validAddress1ContentError: false,
  validAddress2ContentError: false,
  validCityContentError: false,
  validStateContentError: false,
  validZipContentError: false,
  validContactContentError: false,
  validPositionContentError: false,
  validCompensationContentError: false,
  validDescriptionContentError: false,
  validPositionResContentError: false,
  validMinimumQualContentError: false,
  validPreferredQualContentError: false,
  validEmpPolicyContentError: false,
  validPostLinkContentError: false,
};

export default postJobInitialState;
